import {IJobLevelInfo} from "./job-level.interface";
import {consts} from '../common/modals/consts';

export class JobLevelInfo implements IJobLevelInfo{
  id: string;
  index: number;
  name: string;
  description: string;
  examples: string;
  operativeTypeId: string;
  isSelected: boolean;

  constructor(iJobLevelInfo: IJobLevelInfo = null) {
    this.id = iJobLevelInfo?.id || consts.emptyGuid;
    this.index= iJobLevelInfo?.index || 0;
    this.name = iJobLevelInfo?.name || "";
    this.description = iJobLevelInfo?.description || "";
    this.examples = iJobLevelInfo?.examples || "";
    this.operativeTypeId = iJobLevelInfo?.operativeTypeId || "";
    this.isSelected = iJobLevelInfo?.isSelected || false;
  }

  get nameAndExample(): string{
    return this.name + ' (' + this.examples + ')';
  }
}
